import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService} from './api.service';
import {LocalStorageService} from 'ngx-webstorage';

import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import {environment} from '../../../environments/environment';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class AuthService {

    private last_request: string;
    private default_url = 'dashboard';
    private token: string;
    private user: Object = {};
    private sales: Array<Object> = [];
    private source = '';

    constructor(private route: Router, private api: ApiService, private localStorage: LocalStorageService) {
    }

    getSales(): Array<Object> {
        return this.sales;
    }

    initUser(params) {
        this.token = params.token;

        this.initUserData(params.user);
        // Set Token for Api
        this.localStorage.store(environment.token_storage, {'token': this.token, 'bo_user_pk': this.user['pk']});
        this.api.setToken(this.token);

        // Redirect to dashboard o last page
        const url_dest = (typeof this.last_request === 'undefined') ? this.default_url : this.last_request;
        this.route.navigate([url_dest]);
    }

    initUserData(user) {
        this.user = user;
        this.sales = user.counts_and_sales;
    }

    canAccess(urlRequest: string): boolean | Observable<boolean> {
        this.last_request = urlRequest;
        if (this.token) {
            return true;
        } else {
            const tokenObject = this.localStorage.retrieve(environment.token_storage);
            if (tokenObject && tokenObject.hasOwnProperty('token')) {
                this.api.setToken(tokenObject.token);
                return this.api.get('auth/' + tokenObject.bo_user_pk).map(
                    (authResponse) => {
                        if (authResponse.hasOwnProperty('email')) {
                            this.initUserData(authResponse);
                            return true;
                        }
                        this.redirectToLogin();
                        return false;
                    }
                );
            }
        }
        this.redirectToLogin();
        return false;
    }

    setSource(source: string): void {
      this.localStorage.store('ext_source', source);
      this.source = source;
    }

    getSource(): string {
      return (this.source.length > 0) ? this.source : this.localStorage.retrieve('ext_source');
    }

    sendEmailRecover(email: string): Observable<any> {
        return this.api.get('email-recover-pass', {email: email});
    }

    changePasswordFromEmail(email: string, password: string): Observable<any> {
        return this.api.get('change-pass-from-email', {email: email, password: password});
    }

    redirectToLogin() {
        return this.route.navigate([environment.login_page])
    }

    destroy(): Promise<boolean> {
        this.localStorage.clear(environment.token_storage);
        this.localStorage.clear('ext_source');
        this.token = undefined;
        this.user = {};
        return this.redirectToLogin();
    }

    getUser(): object {
        return this.user;
    }
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/core/service/auth.service.ts